module.exports = __webpack_public_path__ + "img/question_mark_icon.2ae546f8.svg";